
<div class="modal-custom">
  <div class="modal-header">
    <h4 class="modal-title"><span class="ml-2">CIS Data Sync</span></h4>
    <button type="button" class="close" data-dismiss="modal" (click)="close()">×</button>
  </div>

  <div class="modal-body">
    <div>
      <div>The CIS Data Sync has begun. This can take anywhere from seconds to 10 minutes.<br><br>
        Please wait 10 minutes before clicking the button again.</div>
  </div>
  <div class="modal-footer mt-4">
    <button type="button" class="btn btn-success" data-dismiss="modal" (click)="close()">Ok</button>
  </div>
</div>
</div>
